
export const toLowerCase = value => String(value).toLowerCase();




/**
 * Recibe un objeto con objetos internos (ejemplo this.props.stats.current) como cadena separada por puntos,
 * itera sobre este objeto preguntando si cada objeto interno existe y retorna el valor si existe, sino
 * retorna null o el valor especificado en defaultReturnValue
 *
 *
 * @param  {String} prop				La cadena con el/los objetos internos a buscar
 * @param  {Object} obj					El objeto en el cual va a buscar
 * @param  {Any} defaultReturnValue 	Un valor por defecto para retornar, en caso de q necesites algo distinto a null (ejm un 0, {}, [])
 * 
 * @return {Any}						El valor contenido en el objeto en el path especificado o null si no existe
 *
 * @example
 *
 * 		// La declaracion de la funcion se puede leer asi:
 * 		// Existe 'length' en 'this'? si no existe usa el array vacio como valor por defecto
 * 		exist('this.props.property.length', this, [])
 * 
 * 
 *		exist('good.picture_urls.0', this) 				// good.picture_urls[0]
 *		exist('this.props.json_lang.component.forgeted_trans', this, []).map( ... )
 *		exist(`this.props.properties.${'algo'+2}.otro`)	// is 'this.props.properties.algo2.otro'
 *
 */
export const exist = (prop, obj, defaultReturnValue = null) => {
  const paths = prop ? prop.split('.') : [];
  let value = obj;
  let idx = 0;

	while (idx < paths.length) {
		if (value == null || value[paths[idx]] == null)
			return defaultReturnValue ? defaultReturnValue : null;

		value = value[paths[idx]];
		idx += 1;
	}

	return defaultReturnValue && !value ? defaultReturnValue : value;
}

/**
 * Function to hanlde the shortcuts or hotkeys in the admin application
 * 
 * WARNING: CAN NOT BE AN ARROW FUNCTION, since it requires the binding to this...
 * 			maybe tweaking a little more could make it work
 */
export const keyboardHotkeys = function (e) {

	if (e.keyCode === 79 && e.altKey && e.shiftKey) { // Alt + shift + o  ---> "o" de orden
		this.props.history.push('/order-management/create');
	}

}


// https://stackoverflow.com/a/27664971/11119545
export const mergeArrays = (...arrayOfArrays) => [...new Set([].concat(...arrayOfArrays))];



//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#Iterating_Sets
//	https://stackoverflow.com/a/44204227/11119545
export const removeFromArray = (originalArray, removableOrders) => [
			...new Set( originalArray.filter(o => !removableOrders.filter(ro => ro.id === o.id).length)) ]

export const userIsUnconfirmed = status => (status > 20 && status <= 127)
 
export const userIsCreatedByAdmin = status => status === 0



// WEBPACK FOOTER //
// ./src/handlers/utils.js